import {Injectable} from '@angular/core';
import {Message} from '../../../operating-standard/chat/message.model';
import {UserService} from '../../../../services/user.service';
import * as moment from 'moment';
import {ReviewSuggestionListsService} from './review-suggestion-lists.service';
import {SuggestionListsService} from './suggestion-lists.service';

@Injectable()
export class ChatSuggestionListsService {

  // чаты от стандарта тут будут храниться
  private slChatMessages: Message[] = [];

  constructor(private userService: UserService,
              public reviewSuggestionListsService: ReviewSuggestionListsService,
              public suggestionListsService: SuggestionListsService) {
  }

  // Добавить сообщение в локальный лист
  addMessage(message) {
    const currentUser = this.userService.getLocal();
    const newMsg = new Message(currentUser.id, currentUser.fullName, message, moment().format('DD.MM.YYYY HH:mm:ss'));

    this.suggestionListsService.addMessageToChat(newMsg).subscribe(
      (res: any) => {
        if (res.status === 200 || res.status === 201 || res.status === 204) {
          this.slChatMessages.reverse();
          this.slChatMessages.push(res.body);
          this.slChatMessages.reverse();
        }
      },
      () => {
      }
    );

  }

  getMessages() {
    return this.suggestionListsService.getSLChatMessages();
  }

  getTempMsg() {
    return this.slChatMessages;
  }

  clearMessages() {
    this.slChatMessages = [];
  }

  setMessages(messages) {
    this.slChatMessages = messages;
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/suggestion-lists/services/chat-suggestion-lists.service.ts